var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',[_vm._v(_vm._s(_vm.group_name))]),_c('el-container',[_c('el-aside',{attrs:{"width":"180px"}},[_c('SubMenu',{attrs:{"activeIndex":"2"}})],1),_c('el-main',[_c('AddOne',{attrs:{"group_id":_vm.group_id}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }